import request from '@/router/axios';
import Family from './family'
import Employment from './employment'
import Certification from './certification'
import Contacts from './contacts'
import Others from './others'
import Personal from './personal'
import Projects from './projects'
import DeveloperProject from './developerProject'
import Education from './education'
import Salary from './salary'
import LeaveRecord from './leaverecord'
import InfoAudit from './infoAudit'
import Benefit from './benefit'
import PositiveRecord from './positiveRecord'
import ExpensePercentage from './expensePercentage'
import NameCard from './nameCard'

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/staff/staffList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
const staffListForComptroller = (current, size, params) => request({
  url: '/api/mcc-staff/staff/staffListForComptroller',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
const verifyRepeat = (params) => request({
  url: '/api/mcc-staff/staff/verifyRepeat',
  method: 'get',
  params: {
    ...params,

  },
})
const authStaffList = (current, size, params) => request({
  url: '/api/mcc-staff/staff/authStaffList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const getAllList = (current, size, params) => request({
  url: '/api/mcc-staff/staff/all',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const page = (current, size, params) => request({
  url: '/api/mcc-staff/staff/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const list = (current, size, params) => request({
  url: '/api/mcc-staff/staff/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const easyList = (current, size, params) => request({
  url: '/api/mcc-staff/staff/getStaffList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
const easyDetail = params => request({
  url: '/api/mcc-staff/staff/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const add = params => request({
  url: '/api/mcc-staff/staff/addStaff',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-staff/staff/staffDetail',
  method: 'get',
  params: {
    ...params,
  },
})

const update = (params, headers) => request({
  url: '/api/mcc-staff/staff/update',
  method: 'post',
  headers,
  data: params,
})

const staffUpdate = (params, headers) => request({
  url: '/api/mcc-staff/staff/staffUpdate',
  method: 'post',
  headers,
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-staff/staff/remove',
  method: 'post',
  params: {
    ids,
  },
})

const exportExcel = params => request({
  url: '/api/mcc-staff/staff/staffExcel',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})

const staffProjectExcel = params => request({
  url: '/api/mcc-staff/staff/staffProjectExcel',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})

const uploadExcel = (filename, file) => {
  const formData = new FormData()
  formData.append(filename, file)
  return request({
    url: '/api/mcc-staff/staff/importStaff',
    method: 'post',
    data: formData,
  })
}

const staffQuit = params => request({
  url: '/api/mcc-staff/staff/quit',
  method: 'post',
  params: {
    ...params,
  },
})

const staffJoin = params => request({
  url: '/api/mcc-staff/staff/employeeRejoining',
  method: 'post',
  params: {
    ...params,
  },
})

const staffConfirmation = params => request({
  url: '/api/mcc-staff/staff/confirmation',
  method: 'post',
  params: {
    ...params,
  },
})

const myAssessmentResult = params => request({
  url: '/api/mcc-staff/processfield/myAssessmentResult',
  method: 'post',
  params: {
    ...params,
  },
})

const isShowMyAssessmentButton = params => request({
  url: '/api/mcc-staff/processfield/isShowMyAssessmentButton',
  method: 'post',
  params: {
    ...params,
  },
})
const getPositiveHandleHistory = (params) => request({
  url: '/api/mcc-staff/positiveHandleHistory/list',
  method: 'get',
  params: {
    ...params,
  },
})
export const staff = {
  getList,
  easyList,
  easyDetail,
  getAllList,
  add,
  detail,
  update,
  remove,
  page,
  list,
  exportExcel,
  staffProjectExcel,
  uploadExcel,
  staffUpdate,
  authStaffList,
  staffQuit,
  staffJoin,
  staffConfirmation,
  myAssessmentResult,
  isShowMyAssessmentButton,
  verifyRepeat,
  staffListForComptroller,
  getPositiveHandleHistory
};
export const family = Family;
export const employment = Employment;
export const certification = Certification;
export const contacts = Contacts;
export const others = Others;
export const personal = Personal;
export const projects = Projects;
export const developerProject = DeveloperProject;
export const salary = Salary;
export const leaverecord = LeaveRecord;
export const education = Education;
export const infoAudit = InfoAudit;
export const benefit = Benefit
export const positiveRecord = PositiveRecord
export const expensePercentage = ExpensePercentage
export const nameCard = NameCard
